import WinLossMember from './WinLossMember'

export default WinLossMember